import { Phone, Mail, MessageCircle, ArrowUpRight } from "lucide-react";
import { COMPANY, WHATSAPP_URL } from "@/lib/constants";

const FooterBrand = () => (
    <div className="lg:col-span-5">
        <img
            src="/logo.jpeg"
            alt="Lavlimpar"
            className="h-28 md:h-32 w-auto object-contain mb-6 bg-white p-3"
            style={{ maxWidth: "260px" }}
        />
        <p className="text-white/55 text-sm leading-relaxed font-light max-w-md mb-3">
            {COMPANY.tagline}.
        </p>
        <p className="text-[#9B2C2C] text-sm font-bold italic max-w-md mb-6">
            “{COMPANY.slogan}”
        </p>
        <a
            data-testid="footer-quote-btn"
            href="#contacto"
            className="group inline-flex items-center gap-2 text-sm font-bold uppercase tracking-wider text-[#9B2C2C] hover:text-[#B83535]"
        >
            Pedir Orçamento
            <ArrowUpRight className="w-4 h-4 group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform" />
        </a>
    </div>
);

const FooterServices = () => (
    <div className="lg:col-span-3">
        <div className="label-tag mb-4">Serviços</div>
        <ul className="space-y-3 text-sm text-white/65">
            <li>Limpeza de Hottes Industriais</li>
            <li>Limpeza de Condutas e Extração</li>
            <li>Limpeza de Motores e Ventiladores</li>
            <li>Manutenção Periódica</li>
        </ul>
    </div>
);

const FooterContact = () => (
    <div className="lg:col-span-4">
        <div className="label-tag mb-4">Contacto</div>
        <ul className="space-y-3 text-sm text-white/80">
            <li>
                <a
                    data-testid="footer-phone"
                    href={`tel:${COMPANY.phoneIntl}`}
                    className="flex items-center gap-3 hover:text-white"
                >
                    <Phone className="w-4 h-4 text-[#9B2C2C]" />
                    {COMPANY.phone}
                </a>
            </li>
            <li>
                <a
                    data-testid="footer-email"
                    href={`mailto:${COMPANY.email}`}
                    className="flex items-center gap-3 hover:text-white"
                >
                    <Mail className="w-4 h-4 text-[#2E7D5B]" />
                    {COMPANY.email}
                </a>
            </li>
            <li>
                <a
                    data-testid="footer-whatsapp"
                    href={WHATSAPP_URL}
                    target="_blank"
                    rel="noreferrer"
                    className="flex items-center gap-3 hover:text-white"
                >
                    <MessageCircle className="w-4 h-4 text-[#25D366]" />
                    WhatsApp
                </a>
            </li>
        </ul>
    </div>
);

const Footer = () => (
    <footer
        data-testid="site-footer"
        className="relative bg-[#0A0A0A] text-white px-6 md:px-12 lg:px-24 py-16"
    >
        <div className="max-w-7xl mx-auto">
            <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 mb-12">
                <FooterBrand />
                <FooterServices />
                <FooterContact />
            </div>

            <div className="border-t border-white/10 pt-8 flex flex-col md:flex-row items-start md:items-center justify-between gap-4 text-xs text-white/40">
                <div>
                    © {new Date().getFullYear()} {COMPANY.name}. Todos os direitos
                    reservados.
                </div>
                <div className="uppercase tracking-widest">
                    Lisboa · Porto · Algarve · Limpeza Técnica de Cozinhas Industriais
                </div>
            </div>
        </div>
    </footer>
);

export default Footer;
